module.exports = __webpack_public_path__ + "static/media/FinX Privacy Policy.237b6928.pdf";